<template>
	<div class="upper-team">
		<el-card shadow="never">
			<template slot="header">
				<el-row type="flex" justify="space-between">
					<span class="row" align-y="center" gutter="5">
						<b>成立小組</b>
						<div class="center bg-black-gray1 color-white" style="border-radius:100%;width:20px;height:20px;">{{num+1}}</div>
					</span>
					<el-button type="danger" size="mini" v-if="!isOnly" @click="removeTeam">點選刪除小組</el-button>
				</el-row>
			</template>
			<el-form label-position="left" label-width="100px" :model="ruleForm" :rules="rules" ref="setUpUpperForm">
				<el-form-item label="小組名稱" prop="teamName">
					<el-input v-model="ruleForm.teamName" placeholder="此小組名稱為方便管理故事資料，非故事名稱"></el-input>
				</el-form-item>
				<el-form-item :label="(i==0)?'小組成員':''" :prop="'members.' + i " v-for="(member, i) in ruleForm.members" :key="i" :rules="{required: true, validator: validateMember, trigger: 'blur'}">
					<div class="col" gutter="10">
						<el-form-item>
							<el-row class="member" type="flex" :gutter="5">
								<el-col :span="10">
									<el-input placeholder="輸入姓名" v-model="member.name"></el-input>
								</el-col>
								<el-col :span="8">
									<el-input placeholder="輸入年齡" v-model="member.age"></el-input>
								</el-col>
								<el-col :span="2">
									<span>歲</span>
								</el-col>
								<el-col :span="8">
									<el-input placeholder="所屬單位" v-model="member.department"></el-input>
								</el-col>
								<el-col :span="2">
									<el-button v-if="ruleForm.members.length > 1" icon="el-icon-minus" type="info" circle size="mini" @click="removeMember(i)"></el-button>
								</el-col>
							</el-row>
						</el-form-item>
						<div v-if="member.id" class="row has-bind" align-x="left" align-y="center" gutter="20">
							<div class="button-tp bind-account-btn color-white bg-black-gray2">已綁定帳號</div>
							<div class="text">{{member.account}}</div>
						</div>
						<div v-else class="button-tp bind-account-btn color-white bg-blue1" align-self="left" @click="toBindAccount(member.index)">已有帳號，點選帶入資料</div>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button icon="el-icon-plus" type="primary" circle size="mini" @click="addMember"></el-button>
				</el-form-item>
				<div class="instructor">
					<el-form-item label="代表人" v-for="(instructor, i) in ruleForm.instructors" :key="i">
						<el-row type="flex" :gutter="10">
							<el-col>
								<div>{{instructor.name}}&emsp;{{instructor.phone}}</div>
							</el-col>
						</el-row>
					</el-form-item>
				</div>
			</el-form>
		</el-card>
		<el-dialog :visible.sync="dialogVisible" :before-close="handleDialogClose">
			<div class="title">
				<span class="center">輸入帳號(email)，連結另一位夥伴</span>
			</div>
			<div class="input-box">
				<el-input placeholder="輸入Email" v-model="otherEmail" @keyup.enter.native="bindingAccount"></el-input>
			</div>
			<div>
				<el-row type="flex" justify="center">
					<el-button type="info" @click="handleDialogClose">取消</el-button>
					<el-button type="danger" class="bg-pink1 color-white" @click="bindingAccount">確定</el-button>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import uuid from "uuid";
import validator from "@/libs/validator";
import { mapState, mapActions, mapMutations } from "vuex";
const _ = require("lodash");

export default {
	props: ["num", "story", "isOnly"],
	data() {
		return {
			dialogVisible: false,
			otherEmail: "",
			selectedMemberIndex: null,
			ruleForm: {
				teamName: "",
				members: [
					{
						index: uuid.v4(),
						name: "",
						department: "",
						age: ""
					}
				],
				instructors: [
					{
						id: "",
						name: "",
						phone: ""
					}
				]
			},
			rules: {
				teamName: [
					{ required: true, message: "請輸入小組名稱", trigger: "blur" }
				]
			}
		};
	},
	computed: {
		...mapState("user", ["userInfo"])
	},
	methods: {
		...mapMutations("story", ["setCreateStory", "deleteCreateStory"]),
		...mapActions("story", ["searchAccount"]),
		handleDialogClose() {
			this.otherEmail = "";
			this.dialogVisible = false;
		},
		toBindAccount(index) {
			this.dialogVisible = true;
			this.selectedMemberIndex = index;
		},
		async bindingAccount() {
			let data = {
				account: this.otherEmail
			};
			try {
				let res = await this.searchAccount(data);
				this.setBindMemberData(res.data);
				this.dialogVisible = false;
				this.otherEmail = "";
			} catch (e) {
				this.$message.error(e);
			}
		},
		setBindMemberData(data) {
			let i = _.findIndex(this.ruleForm.members, {
				index: this.selectedMemberIndex
			});
			this.ruleForm.members[i].id = data.id;
			this.ruleForm.members[i].name = data.name;
			this.ruleForm.members[i].phone = data.phone;
			this.ruleForm.members[i].account = this.otherEmail;
		},
		validateMember(rule, value, callback) {
			if (value.name === "") {
				callback(new Error("請輸入姓名"));
			} else if (value.department === "") {
				callback(new Error("請輸入所屬單位"));
			} else if (value.age === "") {
				callback(new Error("請輸入年紀"));
			} else if (parseInt(value.age) < 18) {
				callback(new Error("挑戰者需要全員皆滿18歲"));
			}
			callback();
		},
		addMember() {
			let data = {
				index: uuid.v4(),
				name: "",
				department: "",
				age: ""
			};
			this.ruleForm.members.push(data);
		},
		removeMember(i) {
			_.pullAt(this.ruleForm.members, i);
			this.ruleForm.members = _.cloneDeep(this.ruleForm.members);
		},
		validatedAll() {
			var result = false;
			this.$refs["setUpUpperForm"].validate(valid => {
				if (valid) {
					result = true;
					this.setStoreCreateStory();
				} else {
					result = false;
				}
			});
			return result;
		},
		setStoreCreateStory() {
			let data = {
				index: this.story.index,
				is_18: this.story.is_18,
				team_name: this.ruleForm.teamName,
				team_members: _.cloneDeep(this.ruleForm.members),
				counselors: _.cloneDeep(this.ruleForm.instructors)
			};

			this.setCreateStory(data);
		},
		removeTeam() {
			this.deleteCreateStory(this.story.index);
		},
		init() {
			this.ruleForm.instructors[0].index = uuid.v4();
			this.ruleForm.instructors[0].id = this.userInfo.id;
			this.ruleForm.instructors[0].name = this.userInfo.name;
			this.ruleForm.instructors[0].phone = this.userInfo.phone;
		}
	},
	created() {
		this.init();
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.bind-account-btn {
	padding: 0 10px;
	height: 25px;
}

.has-bind {
	.text {
		margin-left: 10px;
	}
}

.title {
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 22px;
}

.input-box {
	margin-bottom: 23px;
}
</style>